"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'dyson',
  assets: [{
    description: 'The native staking and governance token of the Dyson Protocol',
    denom_units: [{
      denom: 'dys',
      exponent: 0
    }],
    base: 'dys',
    name: 'Dys',
    display: 'dys',
    symbol: 'DYS',
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg'
    },
    coingecko_id: '',
    images: [{
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/dyson/images/dys.svg'
    }]
  }, {
    denom_units: [{
      denom: 'ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B',
      exponent: 0,
      aliases: ['uosmo']
    }, {
      denom: 'osmo',
      exponent: 6
    }],
    type_asset: 'ics20',
    base: 'ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B',
    name: 'Osmosis',
    display: 'osmo',
    description: 'The native token of Osmosis',
    symbol: 'OSMO',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'osmosis',
        base_denom: 'uosmo',
        channel_id: 'channel-526'
      },
      chain: {
        channel_id: 'channel-2',
        path: 'transfer/channel-2/uosmo'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'osmosis',
        base_denom: 'uosmo'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/osmo.svg'
    }
  }, {
    denom_units: [{
      denom: 'ibc/9BF31153F7E37F687C75A2F310E7A4DB6E0512B065F709B5EB69FE828133AFAC',
      exponent: 0,
      aliases: ['wbtc-satoshi']
    }, {
      denom: 'wbtc',
      exponent: 8
    }],
    type_asset: 'ics20',
    base: 'ibc/9BF31153F7E37F687C75A2F310E7A4DB6E0512B065F709B5EB69FE828133AFAC',
    name: 'Wrapped Bitcoin',
    display: 'wbtc',
    symbol: 'WBTC',
    description: 'Wrapped Bitcoin on Axelar on Osmosis',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'osmosis',
        base_denom: 'ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F',
        channel_id: 'channel-526'
      },
      chain: {
        channel_id: 'channel-2',
        path: 'transfer/channel-2/transfer/channel-208/wbtc-satoshi'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'osmosis',
        base_denom: 'ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/wbtc.png'
    }
  }, {
    denom_units: [{
      denom: 'ibc/13DF61376C08483555C6D4C9203612086A1B23218EB5EBDBE609EEC7EFF2D82D',
      exponent: 0,
      aliases: ['uusdc']
    }, {
      denom: 'usdc',
      exponent: 6
    }],
    type_asset: 'ics20',
    description: "Circle's stablecoin on Axelar on Osmosis",
    base: 'ibc/13DF61376C08483555C6D4C9203612086A1B23218EB5EBDBE609EEC7EFF2D82D',
    name: 'USD Coin',
    display: 'usdc',
    symbol: 'USDC',
    traces: [{
      type: 'ibc',
      counterparty: {
        chain_name: 'osmosis',
        base_denom: 'ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858',
        channel_id: 'channel-526'
      },
      chain: {
        channel_id: 'channel-2',
        path: 'transfer/channel-2/transfer/channel-208/uusdc'
      }
    }],
    images: [{
      image_sync: {
        chain_name: 'osmosis',
        base_denom: 'ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858'
      },
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg'
    }],
    logo_URIs: {
      png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.png',
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/axelar/images/usdc.svg'
    }
  }]
};
var _default = exports["default"] = info;